import React, { useState, useEffect } from 'react';
import './Onboarding.css';

interface OnboardingProps {
  onComplete: () => void;
}

const steps = [
  {
    icon: '🧾',
    title: 'Разделите счёт легко',
    description: 'Я помогу разделить счёт между друзьями — быстро, точно и без споров',
  },
  {
    icon: '📸',
    title: 'Загрузите фото чека',
    description: 'Просто сфотографируйте чек — искусственный интеллект распознает все позиции автоматически',
  },
  {
    icon: '🎯',
    title: 'Выбирайте свои позиции',
    description: 'Каждый отмечает то, что заказывал — приложение посчитает долю каждого',
  },
  {
    icon: '👥',
    title: 'Поделитесь с друзьями',
    description: 'Отправьте ссылку друзьям — они присоединятся и выберут свои позиции',
  },
];

const Onboarding: React.FC<OnboardingProps> = ({ onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [direction, setDirection] = useState<'next' | 'prev'>('next');

  // Плавное появление при монтировании
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    requestAnimationFrame(() => setMounted(true));
  }, []);

  const goToStep = (step: number, dir: 'next' | 'prev') => {
    if (animating) return;
    setAnimating(true);
    setDirection(dir);

    setTimeout(() => {
      setCurrentStep(step);
      setAnimating(false);
    }, 250);
  };

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      goToStep(currentStep + 1, 'next');
    } else {
      onComplete();
    }
  };

  const handleSkip = () => {
    onComplete();
  };

  const step = steps[currentStep];
  const isLast = currentStep === steps.length - 1;

  return (
    <div className={`onboarding ${mounted ? 'onboarding--visible' : ''}`}>
      <div className="onboarding__bg">
        <div className="onboarding__circle onboarding__circle--1" />
        <div className="onboarding__circle onboarding__circle--2" />
        <div className="onboarding__circle onboarding__circle--3" />
      </div>

      <button className="onboarding__skip" onClick={handleSkip}>
        Пропустить
      </button>

      <div className="onboarding__content">
        <div
          className={`onboarding__step ${
            animating
              ? direction === 'next'
                ? 'onboarding__step--exit-left'
                : 'onboarding__step--exit-right'
              : 'onboarding__step--enter'
          }`}
          key={currentStep}
        >
          <div className="onboarding__icon-wrap">
            <div className="onboarding__icon">{step.icon}</div>
          </div>
          <h1 className="onboarding__title">{step.title}</h1>
          <p className="onboarding__desc">{step.description}</p>
        </div>
      </div>

      <div className="onboarding__footer">
        <div className="onboarding__dots">
          {steps.map((_, i) => (
            <button
              key={i}
              className={`onboarding__dot ${i === currentStep ? 'onboarding__dot--active' : ''} ${
                i < currentStep ? 'onboarding__dot--done' : ''
              }`}
              onClick={() => {
                if (i !== currentStep) goToStep(i, i > currentStep ? 'next' : 'prev');
              }}
            />
          ))}
        </div>

        <button className="onboarding__btn" onClick={handleNext}>
          {isLast ? (
            <>
              <span>Начать</span>
              <span className="onboarding__btn-arrow">→</span>
            </>
          ) : (
            <>
              <span>Далее</span>
              <span className="onboarding__btn-arrow">→</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default Onboarding;
